<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.667 4C4.747 4 4 4.746 4 5.667v20.666C4 27.253 4.746 28 5.667 28h20.666c.92 0 1.667-.746 1.667-1.667V5.667C28 4.747 27.254 4 26.333 4H5.667zm18.706 8.541a1 1 0 10-1.413-1.415l-4.935 4.927-2.786-2.783a1 1 0 00-1.413 0l-6.2 6.189a1 1 0 001.414 1.415l5.492-5.483 2.786 2.783a1 1 0 001.413 0l5.642-5.633z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemTrafficFilled'
}
</script>
